<template>
  <qx-card title="账户流水">
    <section slot="titleLeft">
      【金额汇总：
      <span class="primary">{{ totalData.sumAmount || 0 }}</span>
      】
    </section>
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl="oilRechargeAccountBO.ajax?cmd=getOilRechargeAccountDetailsFlow"
          :params="fullSearchData"
          bizName="账户流水记录导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section slot-scope="scope">
              <section
                v-if="scope.column.property === 'orderNum'"
                @click="toOrderIdDetail(scope.row.orderNum)"
              >
                <span class="primary cur">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section v-else>
                {{ scope.row[scope.column.property] }}
              </section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  oilAccountRecordList, // 消费列表
  oilAccountRecordTotal, // 数值总览
} from 'api/service';
import ExportBtn from 'components/exportBtn';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      totalData: {
        sumAmount: 0, // 总金额
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'createDate',
            label: '时间',
          },
          {
            prop: 'accName',
            label: '账户',
          },
          {
            prop: 'billTypeName',
            label: '油类型',
          },
          {
            prop: 'busiName',
            label: '业务类型',
          },
          {
            prop: 'busiCode',
            label: '业务单号',
          },
          {
            prop: 'orderNum',
            label: '订单号',
          },
          {
            prop: 'plateNumber',
            label: '车牌号',
          },
          {
            prop: 'relationName',
            label: '司机/车队',
          },
          {
            prop: 'relationPhone',
            label: '司机/车队账户',
          },
          {
            prop: 'amountDouble',
            label: '金额',
          },
          {
            prop: 'operName',
            label: '操作员',
          },
          {
            prop: 'remark',
            label: '备注',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: oilAccountRecordList,
    toOrderIdDetail (orderId) {
      this.jump({
        label: `订单详情-${orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${orderId}`,
        full: true,
      });
    },
    async getOtherMsg (params) {
      const res = await oilAccountRecordTotal(params);
      if (!res.failed) {
        this.totalData = res;
      }
    },
    toTrans (item) {
      console.log('去交易列表');
    },
    showQrCode (item) {
      this.$refs.qrcodeDialog.show('陈皮');
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
